import { Injectable }       from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { ApiService }         from '../api/api.service';
import { ConfirmService }     from '../messages/confirm/confirm.service';
import { MailchimpListModel } from './typings/mailchimp.list';

@Injectable({
  providedIn: 'root'
})
export class MailchimpService {
  public title = this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.MAILCHIMP.MAILCHIMP');

  constructor (
    private apiService      : ApiService,
    private confirmService  : ConfirmService,
    private translateService: TranslateService
  ) {}

  authorize () : void {
    window.location.assign(`${ this.apiService.getEndpoint() }/mailchimp/auth_mailchimp`);
  }

  getLists () : Promise<Array<MailchimpListModel>> {
    return this.apiService.get('/mailchimp/get_mailchimp_lists');
  }

  sync ( listId : string ) : Promise<any> {
    return this.apiService.get('/mailchimp/mailchimp_batch_upload', listId);
  }

  unauthorize () : Promise<any> {
    return this.confirmService.generic(this.translateService.instant('JS_SPACE.INTEGRATIONS.UNAUTHORISE', {
      name: this.title
    }))
    .then(() => this.apiService.get('/company/remove_mailchimp'));
  }
}
